export const MODULE_ID = 'kendo-globalization';

export const LOAD_MODULE = () => import('@capital-access/kendo-globalization').then(m => m.KendoGlobalizationModule);
